var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCna(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 60,
    viewBox: "0 0 107 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333374,
    width: 106.333,
    height: 60,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6674 20.5557H33.4164C28.2433 20.5557 23.6399 25.1591 23.4028 29.4306C23.1211 34.5017 27.1522 39.4446 31.9927 39.4446H36.5013L39.0639 32.6578H33.4164C30.0467 32.7055 30.4264 26.8676 34.0809 26.8676H41.2947L43.6674 20.5557Z",
    fill: "#CC3232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2098 39.4446L45.3759 20.5557H51.9253L55.6269 30.2373L59.3285 20.5557H65.9256L58.6644 39.4446H52.3998L48.5556 29.3358L44.7589 39.4446H38.2098Z",
    fill: "#CC3232"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.095 25.9661L70.1016 31.234H74.0884L72.095 25.9661ZM75.7966 35.6478H68.4408L66.9697 39.4446H60.4203L67.5867 20.5557H76.6036L83.7697 39.4446H77.2203L75.7966 35.6478Z",
    fill: "#CC3232"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCna);
export default __webpack_public_path__ + "static/media/CNA.040164c7f61e7ec03017c645a15517f5.svg";
export { ForwardRef as ReactComponent };